/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import clsx from 'clsx'
import {useFormik} from 'formik'
import * as Yup from 'yup'

const newPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(3, 'Minimum 3 characters')
    .max(50, 'Maximum 50 characters')
    .required('Password is required'),
  confirmNewPassword: Yup.string()
    .required('Confirm Password is required')
    .when('password', {
      is: (val: string) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf([Yup.ref('password')], 'Both password need to be the same'),
    }),
})

const initialValues = {
  password: '',
  confirmNewPassword: '',
}

export function NewPassword() {
  const [loading, setLoading] = useState(false)

  const [showPassword, setShowPassword] = useState(false)

  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const toggleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const toggleShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword)
  }

  const formik = useFormik({
    initialValues,
    validationSchema: newPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setTimeout(() => {
        setLoading(false)
        setSubmitting(false)
      }, 5000)
    },
  })
  return (
    <>
      <form
        id='kt_login_new_password'
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark mb-3'>Change Password</h1>
          {/* end::Title */}
        </div>

        {/* begin::Form Group */}
        <div className='fv-row mb-4'>
          {/* begin::Label New Password */}
          <label htmlFor='password' className='form-label fw-bolder text-dark fs-6 mb-0'>
            New Password
          </label>
          {/* end::Label New Password */}

          {/* begin::Input New Password */}
          <div className='input-group'>
            <input
              type={showPassword ? 'text' : 'password'}
              {...formik.getFieldProps('password')}
              id='new_password'
              autoComplete='off'
              autoFocus
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.password && formik.errors.password,
                },
                {
                  'is-valid': formik.touched.password && !formik.errors.password,
                }
              )}
            />
            <a className='input-group-text border-0' href='#' onClick={toggleShowPassword}>
              <span
                className={clsx(
                  'fs-5',
                  {'bi-eye-fill': showPassword},
                  {'bi-eye-slash': !showPassword}
                )}
              ></span>
            </a>
          </div>
          {/* end::Input New Password */}

          {/* begin::Alert Password */}
          <div className='fv-plugins-message-container text-danger'>
            <div className='fv-help-block'>
              {!formik.errors.password && (
                <span style={{color: 'rgba(255,255,255,0)'}}>Placeholder</span>
              )}
              {formik.errors.password && <span role='alert'>{formik.errors.password}</span>}
            </div>
          </div>
          {/* end::Alert Password */}
        </div>
        {/* end::Form Group */}

        {/* begin::Form Group */}
        <div className='fv-row mb-4'>
          {/* begin::Label Confirm New Password */}
          <label htmlFor='confirmNewPassword' className='form-label fw-bolder text-dark fs-6 mb-0'>
            Confirm New Password
          </label>
          {/* end::Label Confirm New Password */}

          <div className='input-group'>
            {/* begin::Input Confirm New Password */}
            <input
              type={showConfirmPassword? 'text' : 'password'}
              {...formik.getFieldProps('confirmNewPassword')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid':
                    formik.touched.confirmNewPassword && formik.errors.confirmNewPassword,
                },
                {
                  'is-valid':
                    formik.touched.confirmNewPassword && !formik.errors.confirmNewPassword,
                }
              )}
            />
            <a className='input-group-text border-0' href='#' onClick={toggleShowConfirmPassword}>
              <span
                className={clsx(
                  'fs-5',
                  {'bi-eye-fill': showConfirmPassword},
                  {'bi-eye-slash': !showConfirmPassword}
                )}
              ></span>
            </a>
            {/* end::Input Confirm New Password */}
          </div>

          {/* begin::Alert Confirm New Password */}
          <div className='fv-plugins-message-container text-danger'>
            <div className='fv-help-block'>
              {!formik.errors.confirmNewPassword && (
                <span style={{color: 'rgba(255,255,255,0)'}}>Placeholder</span>
              )}
              {formik.errors.confirmNewPassword && (
                <span role='alert'>{formik.errors.confirmNewPassword}</span>
              )}
            </div>
          </div>
          {/* end::Alert Confirm New Password */}
        </div>
        {/* end::Form Group */}

        {/* begin::Action */}
        <button
          type='submit'
          id='kt_new_password_submit'
          className='btn btn-lg btn-danger w-100 my-4'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Change My Password</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>

        {/* end::Action */}
      </form>
    </>
  )
}
